import { createSlice } from "@reduxjs/toolkit";

import { blogInitialState } from "./blog.initialState";
import {
  getBlogContent,
  getBlogFacts,
  saveServerBlogContent,
  saveServerBlogFacts,
} from "./blog.operations";
import {
  blogContentFulfilledReducer,
  blogContentPendingReducer,
  blogContentRejectedReducer,
  blogFactsFulfilledReducer,
  blogFactsPendingReducer,
  blogFactsRejectedReducer,
} from "./blog.reducer";

const blogSlice = createSlice({
  name: "blog",
  initialState: blogInitialState,
  extraReducers: builder =>
    builder
      .addCase(saveServerBlogContent, blogContentFulfilledReducer)
      .addCase(saveServerBlogFacts, blogFactsFulfilledReducer)

      .addCase(getBlogContent.pending, blogContentPendingReducer)
      .addCase(getBlogContent.rejected, blogContentRejectedReducer)
      .addCase(getBlogContent.fulfilled, blogContentFulfilledReducer)

      .addCase(getBlogFacts.pending, blogFactsPendingReducer)
      .addCase(getBlogFacts.rejected, blogFactsRejectedReducer)
      .addCase(getBlogFacts.fulfilled, blogFactsFulfilledReducer),
});

export const BlogAction = {
  getBlogContent,
  getBlogFacts,
  saveServerBlogContent,
  saveServerBlogFacts,
};

export default blogSlice.reducer;
